export var handlePrintEvents = function () {
    window.addEventListener('beforeprint', function () {
        var accordions = document.querySelectorAll("details:not([open])");
        accordions.forEach(function (accordion) {
            accordion.toggleAttribute('open', true);
            accordion.toggleAttribute('data-open-for-print');
        });
    });
    window.addEventListener('afterprint', function () {
        var accordions = document.querySelectorAll("details[open]");
        accordions.forEach(function (accordion) {
            if (accordion.hasAttribute('data-open-for-print')) {
                accordion.removeAttribute('open');
                accordion.removeAttribute('data-open-for-print');
            }
        });
    });
};
